import { ColumnsType } from '@agro-club/agroclub-shared'
import formatPrice from 'modules/utils/numbers/formatPrice'
import { useMemo } from 'react'

export const useColumns = (): ColumnsType => {
  return useMemo(
    () => [
      {
        width: 140,
        dataIndex: 'title',
      },
      {
        dataIndex: 'value',
        render: (value) => formatPrice(value, true, true),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  )
}
